import PropTypes from 'prop-types'
import React from 'react'
import rem from '@nobia/zeus-components/lib/styled/rem'
import styled from '@nobia/zeus-components/lib/styled'

import CheckboxSVG from './CheckboxSVG'

const Wrapper = styled.div`
  margin: 1px 0 0 1px;
  display: grid;
  @media all and (-ms-high-contrast: none) {
    display: -ms-grid;
  }
`
const IconWrapper = styled.div`
  height: ${p => rem(p.size || 24)};
  grid-column: 1;
  grid-row: 1;
`

const Input = styled.input`
  visibility: hidden;
  height: ${p => rem(p.size || 24)};
  width: ${p => rem(p.size || 24)};
  margin: 0;
  padding: 0;
  grid-column: 1;
  grid-row: 1;
`

const Checkbox = ({ size, checked, bgColor, borderColor, handleChecked }) => (
  <Wrapper>
    <Input
      id="checkbox"
      type="checkbox"
      checked={checked}
      size={size}
      readOnly
    />
    <IconWrapper onClick={() => handleChecked(!checked)} size={size}>
      <CheckboxSVG
        size={size}
        checkmark={{ stroke: checked ? '#192228' : 'white' }}
        checkbox={{
          stroke: borderColor,
          fill: bgColor,
        }}
      />
    </IconWrapper>
  </Wrapper>
)

Checkbox.defaultProps = {
  size: 24,
  checked: false,
  bgColor: '#fff',
  borderColor: '#192228',
  handleChecked: () => {},
}

Checkbox.propTypes = {
  size: PropTypes.number,
  checked: PropTypes.bool,
  bgColor: PropTypes.string,
  borderColor: PropTypes.string,
  handleChecked: PropTypes.func,
}

export default Checkbox
